var $977a6f1e3ef21a90$exports = {};
$977a6f1e3ef21a90$exports = {
    "invalidSelection": (args, formatter)=>`Valgt(e) ${formatter.plural(args.selectedCount, {
            one: `dato`,
            other: `datoer`
        })} er utilgjengelig.`
};


export {$977a6f1e3ef21a90$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
